const Header = () => {
    // TODO: refactor navsolutions
    const navSolutions = document.querySelectorAll('.navSolutions');

    const containerHeaderMain = document.querySelector('[data-component="header-main"]');
    const navContainersPages = document.querySelectorAll('.navContainerPages');

    const buttonA11yOpen = document.querySelector('.button-a11y');
    const buttonA11yClose = document.querySelector('.a11y-close-bar');
    const buttonA11yFontSize = document.querySelectorAll('.change-font-size');
    const buttonA11yContrast = document.querySelectorAll('.change-contrast');

    const buttonHasMegaMenu = document.querySelectorAll('.has-mega-menu > a');
    const buttonCloseMegaMenu = document.querySelectorAll('.close-megamenu');

    const buttonMenu = document.querySelector('.open-menu');
    const buttonCloseMenu = document.querySelectorAll('.close-nav-mobile');

    const buttonSearchBar = document.querySelectorAll('.button-search-bar');
    const buttonCleanInputSearch = document.querySelectorAll('.clean-search-bar');

    const menuLanguage = document.querySelector('.button-menu-language');

    const isMobile = window.matchMedia('(max-width: 768px)').matches;

    buttonHasMegaMenu.forEach((element) => {
        element.addEventListener('click', (event) => {
            let sectionsActive = containerHeaderMain.querySelectorAll('section.active');
            let hrefActive = containerHeaderMain.querySelectorAll('a.active');

            event.preventDefault();
            event.target.classList.toggle('active');
            event.target.nextSibling.classList.toggle('active');


            sectionsActive.forEach((item) => {
                item.classList.remove('active');
            });
            hrefActive.forEach((item) => {
                item.classList.remove('active');
            });
        });
    });

    menuLanguage.addEventListener('click', () => {
        document.querySelector('.menu-language').classList.toggle('active');
    });

    buttonSearchBar.forEach((element) => {
        element.addEventListener('click', () => {
            document.querySelector('.search-bar').classList.toggle('active');
        });
    });

    buttonCleanInputSearch.forEach((element) => {
        element.addEventListener('click', (element) => {
            element.target.parentElement.querySelector('input').value = '';
        });
    });

    buttonMenu.addEventListener('click', () => {
        document.querySelector('.nav-mobile').classList.add('active');
    });

    buttonCloseMenu.forEach((element) => {
        element.addEventListener('click', () => {
            document.querySelector('.nav-mobile').classList.remove('active');
        });
    });

    buttonCloseMegaMenu.forEach((element) => {
        element.addEventListener('click', () => {
            document.querySelectorAll('[data-mega-menu]').forEach((element) => {
                element.classList.remove('active');
            });
        });
    });

    //Todo: fase 2
    navSolutions.forEach((navSolution) => {
        const navSolutionsButton = navSolution.querySelectorAll('button');

        navSolutionsButton.forEach((element) => {
            element.addEventListener('click', (event) => {
                // Remove a classe 'active' do elemento ativo atual dentro do mesmo navSolution
                const activeButton = navSolution.querySelector('.active');
                if (activeButton) {
                    activeButton.classList.remove('active');
                }

                // Encontra o section pai mais próximo e depois o .containerSolutions dentro dele
                const parentSection = navSolution.closest('section');
                if (!parentSection) return;

                const containerSolution = parentSection.querySelector('.containerSolutions');
                if (!containerSolution) return;

                const activeTab = containerSolution.querySelector('[data-tab].active');
                if (activeTab) {
                    activeTab.classList.remove('active');
                }

                // Adiciona a classe 'active' ao botão clicado
                event.target.classList.add('active');

                // Encontra o elemento correspondente ao data-nav-tab dentro do container atual
                const targetTab = containerSolution.querySelector(`[data-tab="${event.target.dataset.navTab}"]`);
                if (targetTab) {
                    targetTab.classList.add('active');
                }
            });
        });
    });

    // navSolutionsButton.forEach((element) => {
    //     element.addEventListener('click', (element) => {
    //         navSolutions.querySelector('.active').classList.remove('active');
    //         containerSolutions.querySelector('#containerSolutions > .active').classList.remove('active');

    //         element.target.classList.add('active');
    //         document.getElementById(element.target.dataset.navTab).classList.add('active');
    //     });
    // });

    if (navContainersPages.length > 0) {
        navContainersPages.forEach((navContainer) => {
            const navContainerPagesButtons = navContainer.querySelectorAll('button'); // Seleciona os botões dentro de cada navContainerPages

            navContainerPagesButtons.forEach((button) => {
                button.addEventListener('click', (event) => {
                    // Remove a classe 'active' de todos os elementos ativos dentro do container atual
                    navContainer.querySelectorAll('.active').forEach((activeElement) => {
                        activeElement.classList.remove('active');
                    });

                    // Adiciona a classe 'active' ao botão clicado e ao seu elemento pai
                    event.target.parentElement.classList.add('active');
                });
            });
        });
    }

    //A11Y
    const fontSize = sessionStorage.getItem('fontSize') ?? 'text-base';
    const contrast = sessionStorage.getItem('contrast') ?? 'light';

    document.querySelector('html').classList.add(fontSize);
    document.querySelector(`button[data-font-size="${fontSize}"]`).classList.add('active');
    document.querySelector('body').classList.add(contrast);

    buttonA11yFontSize.forEach((element) => {
        element.addEventListener('click', (element) => {
            document.querySelector('html').className = '';
            sessionStorage.setItem('fontSize', element.target.dataset.fontSize);
            document.querySelector('html').classList.add(element.target.dataset.fontSize);

            buttonA11yFontSize.forEach((element) => {
                element.classList.remove('active');
            });

            element.target.classList.add('active');
        });
    });

    buttonA11yContrast.forEach((element) => {
        element.addEventListener('click', (element) => {
            document.querySelector('body').className = '';
            sessionStorage.setItem('contrast', element.target.dataset.contrast);
            document.querySelector('body').classList.add(element.target.dataset.contrast);
        });
    });

    buttonA11yOpen.addEventListener('click', () => {
        document.querySelector('.a11y-bar').classList.toggle('active');
    });

    buttonA11yClose.addEventListener('click', () => {
        document.querySelector('.a11y-bar').classList.toggle('active');
    });

    let elemento = document.querySelectorAll('.container')[1];

    if (elemento) {
        let rect = elemento.getBoundingClientRect();
        let distanciaDireita = window.innerWidth - rect.right;
        document.querySelector('.gototop').style.right = `${distanciaDireita + 11}px`;
    }

    let lastScrollTop = 0;

    function detectScrollDirection() {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (scrollTop > lastScrollTop) {
            document.querySelector('.support-menu-header').classList.add('active');
        } else {
            document.querySelector('.support-menu-header').classList.remove('active');
        }

        if (scrollTop > 300) {
            document.querySelector('.gototop').classList.add('opacity-100');
        } else {
            document.querySelector('.gototop').classList.remove('opacity-100');
        }

        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    }

    window.addEventListener('scroll', detectScrollDirection);
};

export default Header;
